import { offlineService, softwareService } from '../../util/mapbox-client';
import * as actionTypes from './action-types';

export const getAtlasDataInfo = ids => {
  return function(dispatch) {
    return Promise.all(
      ids.map(id =>
        offlineService
          .getData({
            id: id
          })
          .send()
          .catch(() => {
            // TODO handle error
          })
      )
    ).then(responses => {
      dispatch({
        type: actionTypes.ATLAS_V1_DATA_LOAD,
        info: responses.map(response => response.body)
      });
    });
  };
};

export const getAtlasServerSoftwareInfo = () => {
  return function(dispatch) {
    return softwareService
      .getSoftwarev1({
        software: 'atlas-server'
      })
      .send()
      .then(response => {
        dispatch({
          type: actionTypes.ATLAS_V1_SOFTWARE_INFO_LOAD,
          info: response.body
        });
      })
      .catch(e => {
        if (e.statusCode === 403) {
          dispatch({
            type: actionTypes.ATLAS_V1_SOFTWARE_NOT_AUTHORIZED,
            info: true
          });
        } else {
          dispatch({
            type: actionTypes.SET_IS_DONE_LOADING_INSTALLER
          });
        }
      });
  };
};
